//setting
export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';
export const GET_CATEGORIES_MENU = 'GET_CATEGORIES_MENU';
export const GET_CATEGORY_FILTERS = 'GET_CATEGORY_FILTERS';
export const GET_VARIABLES = 'GET_VARIABLES';


//category
export const GET_LIST = 'GET_LIST';
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';

//order
export const FAST_BUY = 'FAST_BUY'
export const HISTORY_ORDERS = 'HISTORY_ORDERS'
export const CURRENT_ORDER = 'CURRENT_ORDER'
export const NOVA_POSHTA_GET_TOWNS = 'NOVA_POSHTA_GET_TOWNS'
export const NOVA_POSHTA_GET_DEPARTMENS = 'NOVA_POSHTA_GET_DEPARTMENS'
export const ORDERS_METHODS = 'ORDERS_METHODS'
export const SEARCH = 'SEARCH'
export const CREATE_ORDER = 'CREATE_ORDER'
export const ORDER_STATUS = 'ORDER_STATUS'

//auth
export const REGISTRATION = 'REGISTRATION'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESTORE_PASSWORD = 'RESTORE_PASSWORD'
export const NEW_PASSWORD = 'NEW_PASSWORD'

//user-data
export const UPDATE_DATA = 'UPDATE_DATA'
export const GET_DATA = 'GET_DATA'


//card
export const PRODUCT_DATA = 'PRODUCT_DATA'
export const POPULAR_PRODUCTS = 'POPULAR_PRODUCTS'

//home
export const LATEST_PRODUCTS = 'LATEST_PRODUCTS'
export const HOME_CONTENT = 'HOME_CONTENT'
export const CONTACTS_CONTENT = 'CONTACTS_CONTENT'
export const MENU_CONTENT = 'MENU_CONTENT'
export const ABOUT_CONTENT = 'ABOUT_CONTENT'
export const NEWS = 'NEWS'
export const CURRENT_NEWS = 'CURRENT_NEWS'



